import { Actions, createEffect, ofType } from '@ngrx/effects';
import { inject } from '@angular/core';
import { catchError, concatMap, tap } from 'rxjs/operators';
import {
  LoadFederatedLoginWeb,
  LoadFederatedLoginWebFail,
  LoadFederatedLoginWebSuccess,
} from './auth.actions';
import { IFederatedLoginEnvironmentVariables, LoginFacade } from '@resident-nx/shared';
import { from, map } from 'rxjs';
import { KeycloakService } from '../../services/authentication/keycloak.service';
import { LocalStorageService } from '../../services/storage/local-storage.service';
import { Router } from '@angular/router';

const loadFederatedLoginWeb = createEffect(
  (
    actions$ = inject(Actions),
    loginFacade = inject(LoginFacade),
    localStorageService = inject(LocalStorageService),
    keycloakService = inject(KeycloakService)
  ) => {
    return actions$.pipe(
      ofType(LoadFederatedLoginWeb),
      concatMap(({ redirectUri, email, nonce, state, loginSource }) =>
        loginFacade.getFederatedLoginData(email, nonce, state, redirectUri, loginSource).pipe(
          concatMap(federatedLoginData => {
            const { realm, clientId, baseUrl } = federatedLoginData;
            localStorageService.setItem(IFederatedLoginEnvironmentVariables.REALM, realm);
            localStorageService.setItem(IFederatedLoginEnvironmentVariables.CLIENT_ID, clientId);
            localStorageService.setItem(IFederatedLoginEnvironmentVariables.BASE_URL_AUTH, baseUrl);

            return from(
              keycloakService.init(
                {
                  url: baseUrl,
                  realm,
                  clientId,
                },
                { redirectUri }
              )
            );
          }),
          map(authenticated => LoadFederatedLoginWebSuccess({ authenticated, email })),
          catchError((error: Error) => [LoadFederatedLoginWebFail({ error })])
        )
      )
    );
  },
  { functional: true }
);

const loadFederatedLoginWebSuccess = createEffect(
  (
    actions$ = inject(Actions),
    router = inject(Router),
    keycloakService = inject(KeycloakService)
  ) =>
    actions$.pipe(
      ofType(LoadFederatedLoginWebSuccess),
      tap(({ authenticated, email }) => {
        if (authenticated) {
          void router.navigate(['/auth']);
        } else {
          void keycloakService.login({ loginHint: email });
        }
      })
    ),
  { functional: true, dispatch: false }
);

export const authWebEffects = [loadFederatedLoginWeb, loadFederatedLoginWebSuccess];
